import { configureStore } from "@reduxjs/toolkit";
import TravelPayloadCurrentScreenSplice from "./CurrentTravelScreen";
import GroupMembersSlice from "./GroupMembers";
import GroupQuotesPayloadSlice from "./GroupPayload";
import IndividualQuotesPayloadSlice from "./IndividualPayload";
import StepSlice from "./Steps";
import TenantCredsSlice from "./TenantCreds";
import ProfileSlice from "./UserProfileData";

const store = configureStore({
    reducer: {
        step: StepSlice.reducer,
        individualData: IndividualQuotesPayloadSlice.reducer,
        groupData: GroupQuotesPayloadSlice.reducer,
        groupMembers: GroupMembersSlice.reducer,
        travelPayloadCurrentScreen: TravelPayloadCurrentScreenSplice.reducer,
        profile: ProfileSlice.reducer,
        tenantCreds: TenantCredsSlice.reducer
    }
})

export default store